/**
 * CompletableSection — Section wrapper with completion checkmark
 * Replaces the raw <div> + <h3> pattern in tabs with a section
 * that has a toggleable completion indicator in the header
 * Sprint 8 — S8-24
 */

import { SectionCompleteButton } from './SectionCompleteButton'

export interface CompletableSectionProps {
  sectionId: string
  title: string
  isComplete: boolean
  completedByName?: string | null
  completedAt?: string | null
  onToggle: () => void
  children: React.ReactNode
}

export function CompletableSection({
  sectionId,
  title,
  isComplete,
  completedByName,
  completedAt,
  onToggle,
  children,
}: CompletableSectionProps) {
  return (
    <div
      data-section-id={sectionId}
      className="bg-[#1e1e38] border border-[#2a2a44] rounded-xl p-5"
      style={{
        borderColor: isComplete ? 'rgba(34, 197, 94, 0.25)' : undefined,
      }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-[13px] font-medium text-[#e8e8f0]">
          {title}
        </h3>
        <SectionCompleteButton
          isComplete={isComplete}
          completedByName={completedByName}
          completedAt={completedAt}
          onToggle={onToggle}
        />
      </div>
      {children}
    </div>
  )
}

export default CompletableSection
